import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class UploadIcon extends Component {
    static propTypes = {
        color: PropTypes.string,
    };

    static defaultProps = {
        color: '#8A8A8F',
    };

    render() {
        return (
            <svg width="22px" height="22px" viewBox="0 0 26 26" version="1.1">
                <defs></defs>
                <g
                    id="Graphics-/-Custom-Icons-/-iMessage-/-Close"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                >
                    <path
                        d="M18.1647143,16.2277143 C18.7032857,16.7662857 18.707,17.6298571 18.1684286,18.1702857 C17.6354286,18.7032857 16.7681429,18.707 16.2277143,18.1665714 L12.9981429,14.9388571 L9.77042857,18.1665714 C9.23,18.7032857 8.36828571,18.707 7.82971429,18.1702857 C7.29485714,17.6335714 7.293,16.77 7.83342857,16.2277143 L11.0611429,13 L7.83342857,9.77228571 C7.29857143,9.23557143 7.293,8.372 7.82971429,7.83157143 C8.36457143,7.29485714 9.22814286,7.293 9.77042857,7.83157143 L12.9981429,11.0592857 L16.2277143,7.83157143 C16.7644286,7.29671429 17.6317143,7.293 18.1684286,7.83157143 C18.7032857,8.36642857 18.707,9.22814286 18.1647143,9.77228571 L14.9388571,13 L18.1647143,16.2277143 Z M13,0 C5.82214286,0 0,5.82214286 0,13 C0,20.1778571 5.82214286,26 13,26 C20.1797143,26 26,20.1778571 26,13 C26,5.82214286 20.1797143,0 13,0 L13,0 Z"
                        id="Close-Icon"
                        fill={this.props.color}
                        transition="fill 0.3s ease-out"
                        transform="translate(13.000000, 13.000000) rotate(45.000000) translate(-13.000000, -13.000000) "
                    ></path>
                </g>
            </svg>
        );
    }
}
